/**
 * Alerts screen - dose threshold status
 */

import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useDoseStore, useUserStore } from '../store';
import { checkDoseThreshold } from '../services';

export function AlertsScreen() {
  const getAnnualMicroSv = useDoseStore((s) => s.getAnnualMicroSv);
  const settings = useUserStore((s) => s.settings);

  const annualDose = getAnnualMicroSv();
  const result = checkDoseThreshold(
    annualDose,
    settings.alertThresholdMicroSv
  );

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Alerts</Text>
      <View
        style={[
          styles.alertBox,
          result.shouldAlert ? styles.alertWarning : styles.alertOk,
        ]}
      >
        <Text style={styles.alertText}>
          {result.shouldAlert
            ? `Annual dose (${(result.currentMicroSv / 1_000_000).toFixed(2)} mSv) exceeds threshold (${(result.thresholdMicroSv / 1_000_000).toFixed(2)} mSv)`
            : `Annual dose (${(result.currentMicroSv / 1_000_000).toFixed(2)} mSv) is below threshold (${(result.thresholdMicroSv / 1_000_000).toFixed(2)} mSv)`}
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, padding: 20 },
  title: { fontSize: 24, fontWeight: '700', marginBottom: 16 },
  alertBox: {
    padding: 16,
    borderRadius: 8,
    borderWidth: 1,
  },
  alertOk: { backgroundColor: '#e8f5e9', borderColor: '#4caf50' },
  alertWarning: { backgroundColor: '#fff3e0', borderColor: '#ff9800' },
  alertText: { fontSize: 16 },
});
